var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-wrapper',{attrs:{"instance":_vm.instance}},[_c('p',[_vm._v("More Information Footer")]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }